import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}

// Log configuration in development (for debugging)
if (import.meta.env.DEV) {
  console.log('[Firebase Config] Initializing with:', {
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    apiKeyPresent: !!firebaseConfig.apiKey,
    appIdPresent: !!firebaseConfig.appId
  })
}

// Validate required configuration
const requiredFields = ['apiKey', 'authDomain', 'projectId', 'appId']
const missingFields = requiredFields.filter(field => !firebaseConfig[field])

if (missingFields.length > 0) {
  console.error('[Firebase Config] Missing required fields:', missingFields)
  console.error('[Firebase Config] Please check your .env file and ensure all VITE_FIREBASE_* variables are set')
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Log the current hostname for debugging redirect issues
console.log('[Firebase Config] Current hostname:', window.location.hostname)
console.log('[Firebase Config] Current full URL:', window.location.href)
console.log('[Firebase Config] Auth domain configured:', firebaseConfig.authDomain)
console.log('[Firebase Config] Project ID:', firebaseConfig.projectId)

if (window.location.hostname !== 'localhost' && 
    window.location.hostname !== '127.0.0.1' &&
    window.location.hostname !== firebaseConfig.authDomain.replace('.firebaseapp.com', '.web.app') &&
    window.location.hostname !== firebaseConfig.authDomain) {
  console.warn('[Firebase Config] ⚠️ HOSTNAME MISMATCH DETECTED')
  console.warn('[Firebase Config] Current hostname:', window.location.hostname)
  console.warn('[Firebase Config] Configured authDomain:', firebaseConfig.authDomain)
  console.warn('[Firebase Config] This WILL cause redirect authentication to fail!')
  console.warn('[Firebase Config] Solutions:')
  console.warn('[Firebase Config] 1. Add "' + window.location.hostname + '" to Firebase Console > Authentication > Settings > Authorized domains')
  console.warn('[Firebase Config] 2. Clear browser cache and cookies')
  console.warn('[Firebase Config] 3. Try again with a fresh session')
}

export default app